import styled from '@emotion/styled';
import { Box, FormControl } from '@mui/material';
import { Select } from 'src/components-dummy';

export const FiltersRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

export const StyledFormControl = styled(FormControl)(({ theme }) => ({
  backgroundColor: theme.palette.custom['gray-70'],
  borderRadius: 8,
  minWidth: 150,
  '.MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
}));

export const StyledSelect = styled(Select)(({ theme }) => ({
  color: theme.palette.custom['black-10'],
  fontWeight: 500,
  '.MuiSelect-select': {
    padding: '8px 32px 8px 12px',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
}));
